import React from 'react';

export const FormGroup = ({
  children
}: {
  children: React.ReactElement | React.ReactElement[];
}) => <div style={{ marginBottom: '15px' }}>{children}</div>;
